import * as Yup from "yup";

const EditCompanyInfoSchema = Yup.object().shape({
  companyName: Yup.string().nullable(),
  industry: Yup.string().nullable(),
  contactPerson: Yup.string().nullable(),
  contactNumber: Yup.string().nullable(),

  email: Yup.string().email("Please enter a valid email address").required("Email is required"),
});

export default EditCompanyInfoSchema;
